import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import globalThis from 'core-js/stable/global-this';
import '@lit/reactive-element/polyfill-support.js';
import '@webcomponents/webcomponentsjs/webcomponents-bundle.js';

if (!window.globalThis) {
  window.globalThis = globalThis;
}
